import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import classNames from "classnames"
import instanceOfClassName from "@kaspernj/api-maker/build/instance-of-class-name"
import Link from "@kaspernj/api-maker/build/link"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
/**
 * @typedef {object} ComponentsSurveysLinkProps
 * @property {unknown} adminLayout
 * @property {unknown} children
 * @property {string} className
 * @property {unknown} survey
 * @property {unknown} userLayout
 */

/** @typedef {object} ComponentsSurveysLinkState */

/**
 * @extends {ShapeComponent<ComponentsSurveysLinkProps, ComponentsSurveysLinkState>}
 */
class ComponentsSurveysLink extends ShapeComponent {
  static defaultProps = {
    adminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    survey: instanceOfClassName("Survey").isRequired,
    userLayout: PropTypes.bool.isRequired
  }

  render() {
    const {adminLayout, children, className, survey, userLayout, ...restProps} = this.props
    const generatedClassName = classNames("components--surveys--link", className)

    if (adminLayout) {
      return (
        <Link className={generatedClassName} to={this.to()} {...restProps}>
          {children || survey.name()}
        </Link>
      )
    }

    return (
      <span className={generatedClassName} {...restProps}>
        {children || survey.name()}
      </span>
    )
  }

  to() {
    const {adminLayout, survey} = this.p

    if (adminLayout) return Routes.adminSurveyPath(survey.id())

    return "#"
  }
}

export default memo(shapeComponent(ComponentsSurveysLink))
